import shadows from "assets/stylesheets/modules/variables/shadow.module.scss";

export default {
  ...shadows,
  outline: "0 0 0 3px var(--chakra-ui-color-muted)",
};
